import AuthService from '../services/auth.service';

const usr = JSON.parse(sessionStorage.getItem('user'));
const user = JSON.parse(sessionStorage.getItem('token'));
const initialState = user
  ? { status: { loggedIn: true }, user, usr }
  : { status: { loggedIn: false }, user: null, usr: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    verify({ commit }, token) {
      return AuthService.verifyUser(token).then(
        usr => {
          commit('verifySuccess', usr);
          return Promise.resolve(usr);
        },
        error => {
          commit('verifyFailure');
          return Promise.reject(error);
        }
      )
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    verifySuccess(state, usr) {
      state.usr = usr;
    },
    verifyFailure(state) {
      state.usr = null;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    }
  }
};
